const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_BASE_URL = {
  LOGIN: `${BASE_URL}/auth`,
  SIGNUP: `${BASE_URL}/auth/signup`,
  ENTIDADE: `${BASE_URL}/entidade`,
  ORGAO: `${BASE_URL}/orgao`,
  ORGAO_DEPARTAMENTO: `${BASE_URL}/orgao_departamento`,
  ORGAO_FUNCIONARIO: `${BASE_URL}/orgao_funcionario`,
  PESSOA: `${BASE_URL}/pessoa`,
  EMISSOR: `${BASE_URL}/emissor`,
  ATA: `${BASE_URL}/ata`,
  USUARIO: `${BASE_URL}/usuario`,
  VINCULO: `${BASE_URL}/vinculo`,
  UF: `${BASE_URL}/uf`,
  MUNICIPIO: `${BASE_URL}/municipio`,
  CNPJ_PROXY: `${BASE_URL}/cnpj`,
  AUDIT_LOG: `${BASE_URL}/audit_log`,
  IMAGEM: `${BASE_URL}/imagem`,
  PARAMETRO: `${BASE_URL}/parametro`,
  DEMANDA: `${BASE_URL}/demanda`,
  DEMANDA_ITEM: `${BASE_URL}/demanda_item`,
  REPORT_MARGIN: `${BASE_URL}/report_margin`,
};
